import { FC } from "react";
import { useFormContext } from "react-hook-form";

interface Props {
  name: string;
  required?: boolean;
  type?: HTMLInputElement["type"];
}

export const InputText: FC<Props> = ({ name, type, required }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <input
        type={type || "text"}
        className="form-control"
        {...register(name, {
          validate: (value) => {
            if (required) {
              const parsedValue = value?.trim();
              if (!parsedValue) return "Por favor, preencha este campo.";
            }
          },
        })}
      />
      {errors?.[name] && (
        <span className="field-error-message">
          {(errors[name]?.message as any) || "Inválido"}
        </span>
      )}
    </>
  );
};
